export function HandleIcon() {
    return <svg width="24" height="24" viewBox="0 0 100 100" fill="none">
        <circle cx="28" cy="50" r="9" fill={"currentColor"}/>
        <circle cx="28" cy="21" r="9" fill={"currentColor"}/>
        <circle cx="71" cy="21" r="9" fill={"currentColor"}/>
        <circle cx="71" cy="50" r="9" fill={"currentColor"}/>
        <circle cx="71" cy="78" r="9" fill={"currentColor"}/>
        <circle cx="28" cy="78" r="9" fill={"currentColor"}/>
    </svg>;
}
